import { LoadPanel, ScrollView, TextArea, TextBox } from 'devextreme-react';
import { useCallback, useEffect, useState } from 'react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { useScreenSize } from '../../../../../utils/media-query';
import { useApiPatient } from '../../../../../api/api.patient';
import { TypeTableFilter } from '../../../../../types/types.system';
import Form, { Item, ButtonItem, ButtonOptions } from 'devextreme-react/form';
import { formatMessage } from 'devextreme/localization';
import { Paciente } from '../../../../../types/types.patient';
import { newToast } from '../../../..';
import { setCurrentPatientToTransfer } from '../../../../../contexts/slices/orders';
import { useApiOrders } from '../../../../../api/api.orders';

export const ModalTransferOrder = ({ visible, setVisible }) => {
  const { isMedium, isSmall } = useScreenSize();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingSend, setLoadingSend] = useState<boolean>(false);
  const [newPatient, setNewPatient] = useState<Paciente | undefined>(undefined);
  const [document, setDocument] = useState('');
  const [confirmNote, setConfirmNote] = useState<string>('');
  const patient = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData);
  const CurrentPatientToTransfer = useAppSelector((x) => x.globalOrders.CurrentPatientToTransfer);
  const { transferOrder } = useApiOrders();
  const { findUser } = useApiPatient();

  const handleSubmit = useCallback(() => {
    if (!document) {
      newToast('WARNING', 'Debe digitar un documento a buscar', 5);
      return;
    }
    if (patient.Pc_Identificacion === document) {
      newToast('WARNING', 'Debe seleccionar un paciente diferente al actual', 5);
      return;
    }
    findUser([{ TypeFilter: TypeTableFilter.Equal, Field: 'Pc_Identificacion', Value: document }], setLoading, false, 'orders').then((res) => {
      if (res) {
        setNewPatient(res.Paciente);
      }
    });
  }, [document]);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    setNewPatient(CurrentPatientToTransfer);
  }, [CurrentPatientToTransfer]);

  useEffect(() => {
    setDocument('');
    setNewPatient(undefined);
    if (visible) {
      dispatch(setCurrentPatientToTransfer(undefined));
    }
  }, [visible]);

  const onValueChange = (e) => {
    setDocument(e);
  };

  const handleConfirm = useCallback(async () => {
    if (!newPatient) {
      newToast('WARNING', 'Por favor busque el nuevo paciente a transferir', 5);
      return;
    }
    if (!confirmNote) {
      newToast('WARNING', 'Debe ingresar una nota de confirmación', 5);
      return;
    }
    setLoadingSend(true)
    transferOrder(newPatient.Pc_Id, confirmNote).then((res) => {
      if (res) {
        handleClose();
        setLoadingSend(false)
      }
    });
  }, [newPatient, confirmNote]);

  const handleChange = useCallback(
    (e) => {
      setConfirmNote(e);
    },
    [confirmNote]
  );

  return (
    <Popup visible={visible} fullScreen={isMedium||isSmall} onHidden={handleClose} width={400} height={'auto'} title={'Transferir orden'}>
      <ScrollView>
        <form onSubmit={handleSubmit} className='textarea-note-confirm'>
          {loading && <LoadPanel showPane={false} visible container={'.panelPatient2'} position={{ of: '.panelPatient2' }} />}
          <Form colCount={1} labelMode='static'>
            <Item>
              <TextBox stylingMode='outlined' value={document} validationError={null} maskInvalidMessage={formatMessage('invalidFormat')} label={formatMessage('PatientField')} onValueChange={onValueChange} />
            </Item>
            <ButtonItem visible={false}>
              <ButtonOptions text='Enviar' useSubmitBehavior={true} />
            </ButtonItem>
          </Form>
        </form>

        <h6 className='transfer-data-patient-header'>Paciente actual</h6>
        <p className='transfer-data-patient'>
          <strong>Documento:</strong> {patient.Pc_Identificacion} &nbsp;|&nbsp;
          <strong>Nombre:</strong> {patient.Pc_Nombre} {patient.Pc_Apellido1} {patient.Pc_Apellido2}
        </p>
        <i className='dx-icon dx-icon-arrowdown'></i>

        <h6 className='transfer-data-patient-header new-patient panelPatient2'>Nuevo paciente</h6>
        <p className='transfer-data-patient new-patient'>
          <strong>Documento:</strong> {newPatient?.Pc_Identificacion || '---'} &nbsp;|&nbsp;
          <strong>Nombre:</strong> {newPatient?.Pc_Nombre || '---'} {newPatient?.Pc_Apellido1 || ''} {newPatient?.Pc_Apellido2 || ''}
        </p>
        <div className='textarea-note-confirm'>
          <TextArea maxLength={500} height={100} label='Motivo de transferencia' inputAttr={{ 'aria-label': 'Notes' }} autoResizeEnabled={true} onValueChange={handleChange} />
        </div>
      </ScrollView>
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: 'CANCELAR', type: 'normal', onClick: handleClose }} />
      <ToolbarItem widget='dxButton' toolbar='bottom' location='after' options={{ text: loadingSend ? 'PROCESANDO...' : 'CONFIRMAR', stylingMode: 'contained', type: 'default', onClick: handleConfirm, disabled: loadingSend }} />
    </Popup>
  );
};
